import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useNeuerAuftragMutation } from "../../api/AuftragAPI";
import MapComponent, { ILocation } from "../../component/MapComponent/MapComponent";
import UploadContainer from "../../component/UploadContainer";
import { upload } from "../../services/All";
import { setModalMessageOkDialogVisible } from '../../Slice/DialogSlice';
import { AppDispatch } from '../../Store';
import { IAuftragRequest } from '../../types/Types';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './neuerauftrag.module.scss';

export const emptyAuftrag: IAuftragRequest = {
  uid: '',
  art: '',
  vorname_endkunde: '',
  name_endkunde: '',
  strasse_lieferadresse: '',
  hausnummer_lieferadresse: '',
  postleitzahl_lieferadresse: '',
  stadt_lieferadresse: '',
  land_lieferadresse: '',
  spaetmesstermin: null,
  telefon_lieferadresse: '',
  besonderheiten: '',
  messzeitpunkt: '',
  email_lieferadresse: '',
  mobil1_lieferadresse: '',
  mobil2_lieferadresse: '',
  ansprechpartner: '',
  kontakt_ansprechpartner: '',
  auftragsnr_ag: '',
  lat: 0,
  lng: 0,
}

const libraries: ("places")[] = ["places"];

type IErrorType = {
  art?: string,
  auftragsnr_ag?: string,
  name_endkunde?: string,
  vorname_endkunde?: string,
  adresse?: string,
  telefon_lieferadresse?: string,
}

/**
 * @author noone
 */
export default function NeuerAuftrag() {

  const navigate = useNavigate();
  const [auftragRequest, setAuftragRequest] = useState<IAuftragRequest>(emptyAuftrag);
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [neuerAuftragAPI] = useNeuerAuftragMutation();
  const [spaetmesstermin, setSpaetmesstermin] = useState<string>(""); // ist nicht schön, ich weiss
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const [errors, setErrors] = useState<IErrorType>({});

  const [messzeitpunkt1, setMesszeitpunkt1] = useState<string>("");
  const [messzeitpunkt2, setMesszeitpunkt2] = useState<string>("");

  const validate = () => {
    const newErrors: IErrorType = {};

    /*
    if (!auftragRequest.auftragsnr_ag || auftragRequest.auftragsnr_ag === "") {
      newErrors.auftragsnr_ag = "Eigene Auftragsnummer darf nicht leer sein.";
    }

    if (!auftragRequest.vorname_endkunde || auftragRequest.vorname_endkunde === "") {
      newErrors.vorname_endkunde = "Vorname des Endkunden darf nicht leer sein.";
    }

    if (!auftragRequest.name_endkunde || auftragRequest.name_endkunde === "") {
      newErrors.name_endkunde = "Name des Endkunden darf nicht leer sein.";
    }

    if (!auftragRequest.art || auftragRequest.art === "") {
      newErrors.art = "Auftragsart darf nicht leer sein.";
    }

    if (!auftragRequest.stadt_lieferadresse || auftragRequest.stadt_lieferadresse === "") {
      newErrors.adresse = "Stadt der Lieferadresse darf nicht leer sein.";
    }

    if (
      (!auftragRequest.telefon_lieferadresse || auftragRequest.telefon_lieferadresse === "")
      && (!auftragRequest.mobil1_lieferadresse || auftragRequest.mobil1_lieferadresse === "")
      && (!auftragRequest.mobil2_lieferadresse || auftragRequest.mobil2_lieferadresse === "")
      && (!auftragRequest.email || auftragRequest.email === "")
    ) {
      newErrors.telefon_lieferadresse = "Mindestens eine Telefon, Mobilfunknummer oder E-Mailadresse muss angegeben werden.";
    }
    */

    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
    return Object.keys(newErrors).length === 0; // true, wenn keine Fehler
  };

  useEffect(() => {
    setAuftragRequest((prevData) => ({
      ...prevData,
      messzeitpunkt: messzeitpunkt1 + (messzeitpunkt1 ? "_" : "") + messzeitpunkt2
    }));

    if (messzeitpunkt2 !== "eilig") {
      setSpaetmesstermin("");
    }
  }, [messzeitpunkt2]);

  const arten = [
    { art: 'Küche', text: 'Küche' },
    { art: 'HWR', text: 'HWR' },
    { art: 'API', text: 'API' },
    { art: 'Neubau', text: 'Neubau' },
    { art: 'Altbau', text: 'Altbau' },
    { art: 'Küchenumbau', text: 'Küchenumbau' },
    { art: 'Sonstiges', text: 'Sonstiges' },
  ]

  /*const noEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };*/

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAuftragRequest((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));

    if (e.target.name === "spaetmesstermin") {
      setSpaetmesstermin(e.target.value);
    }
  }

  const handleChangeTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAuftragRequest((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setAuftragRequest((prev) => ({ ...prev, art: e.target.value }));
  }

  const speichern = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    // Validieren
    if (!validate()) return;

    // Auftrag senden
    neuerAuftragAPI(auftragRequest)
      .unwrap().then(auftrag => {

        // Fotos hochladen
        uploadedFiles.map((file) =>
          upload(auftrag.uid, file));
        return auftrag;
      })
      .then((auftrag) => {

        //
        dispatch(setModalMessageOkDialogVisible({
          visible: true,
          text: 'Erfolgreich gespeichert!'
        }));

        // Weiter
        navigate("/eigeneauftraege/detail/" + auftrag.uid);

      });

  }

  const handleFilesChange = (files: File[]) => {
    setUploadedFiles(files);
  };

  const locationset = (location: ILocation) => {
    console.log("locationset!! ", location);
    //console.log("address_components", location.place?.address_components);
    setAuftragRequest((prevData) => ({
      ...prevData,
      strasse_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'route')?.long_name || '',
      hausnummer_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'street_number')?.long_name || '',
      postleitzahl_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'postal_code')?.long_name || '',
      stadt_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'locality')?.long_name || '',
      land_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'country')?.long_name || '',
      lat: location.lat,
      lng: location.lng,
    }));
    //console.log(auftragRequest);
  };

  const setWith100PercentForInputMapField = () => {
    const interval = setInterval(() => {
      // finde das Element mit Klasse "autocomplete-control"
      const autocompleteControl = document.querySelector(".autocomplete-control");
      if (autocompleteControl && autocompleteControl.parentElement) {
        // setze style am Eltern-Element
        autocompleteControl.parentElement.style.width = "100%";
        autocompleteControl.parentElement.style.left = "0px";
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }

  useEffect(() => {

    setWith100PercentForInputMapField();

  }, []);

  return (
    <div className={classNames(styles.centerContainer)}>

      <LandingpageHeader />

      <div className="container">

        <button
          onClick={() => {
            navigate({
              pathname: "/",
              search: ""
            });
          }}

          style={{ marginBottom: "20px" }}
          className=' btn btn-outline-primary'
        >
          <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
        </button>

        <h3>{t('deTranslation.neuerAuftrag.titel')}</h3>

        <form onSubmit={speichern}>

          <div className="form-group">
            Art: <select required={true} className='form-control' name="art" value={auftragRequest?.art} onChange={handleChangeSelect} >
              <option value="">-- Bitte auswählen --</option>
              {arten.map((e) =>
                <option key={e.art} value={e.art}>{e.text}</option>
              )}

            </select>
            {errors.art && <p className="text-red-500">{errors.art}</p>}
          </div>

          <div className="form-group">
            Eigene Auftragsnummer:
            <input required={true} className='form-control' name="auftragsnr_ag" value={auftragRequest?.auftragsnr_ag} onChange={handleChange} />
            {errors.art && <p className="text-red-500">{errors.auftragsnr_ag}</p>}
          </div>

          <div className="form-group">
            Messzeitpunkt:

            <select className='form-control' name='messzeitpunkt1' style={{ width: "auto", display: "inline" }} onChange={(e) => { e.preventDefault(); setMesszeitpunkt1(e.target.value); setMesszeitpunkt2("0"); }}>
              <option value="">-- Bitte auswählen --</option>
              <option value="1">Neubau</option>
              <option value="2">Sanierung</option>
              <option value="3">Bestand</option>
            </select>

            {messzeitpunkt1 === "1" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <select className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
                  <option value="">-- Bitte auswählen --</option>
                  <option value="sofort">Sofort</option>
                  <option value="nach_putz">Nach Putz</option>
                  <option value="nach_estrich">Nach Estrich</option>
                  <option value="eilig">Eilig (mit Datumsangabe)</option>
                </select>
              </>
            }

            {messzeitpunkt1 === "2" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <select className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
                  <option value="">-- Bitte auswählen --</option>
                  <option value="sofort">Sofort</option>
                  <option value="nach_putz">Nach Putz</option>
                  <option value="nach_estrich">Nach Estrich</option>
                  <option value="eilig">Eilig (mit Datumsangabe)</option>
                </select>
              </>
            }

            {messzeitpunkt1 === "3" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <select className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
                  <option value="">-- Bitte auswählen --</option>
                  <option value="sofort">Sofort</option>
                  <option value="eilig">Eilig (mit Datumsangabe)</option>
                </select>
              </>
            }

            {messzeitpunkt2 === "eilig" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <input type="date" className='form-control' style={{ width: "auto", display: "inline" }} name="spaetmesstermin" value={spaetmesstermin} onChange={handleChange} />
              </>
            }

          </div>

          <div className="form-group">
            Vorname Endkunde*:
            <input required={true} className='form-control' name="vorname_endkunde" value={auftragRequest?.vorname_endkunde} onChange={handleChange} />
            {errors.vorname_endkunde && <p className="text-red-500">{errors.vorname_endkunde}</p>}
          </div>

          <div className="form-group">
            Name Endkunde*:
            <input required={true} className='form-control' name="name_endkunde" value={auftragRequest?.name_endkunde} onChange={handleChange} />
            {errors.name_endkunde && <p className="text-red-500">{errors.name_endkunde}</p>}
          </div>

          <div className="form-group">
            Lieferadresse:
          </div>

          <div style={{ height: '500px', width: '100%' }}>
            {errors.adresse && <p className="text-red-500">{errors.adresse}</p>}
            <MapComponent onLocationSet={locationset} />
          </div>

          {/*}
          <div className="card" style={{ padding: "20px", marginBottom: "30px" }}>
            Lieferadresse:
            <p></p>
            <br />{auftragRequest.vorname_endkunde} {auftragRequest.name_endkunde}
            <br />{auftragRequest.strasse_lieferadresse} {auftragRequest.hausnummer_lieferadresse}
            <br />{auftragRequest.postleitzahl_lieferadresse} {auftragRequest.stadt_lieferadresse}
            <br />{auftragRequest.land_lieferadresse}
            <br />Geokoordinate: {auftragRequest.lat} , {auftragRequest.lng}
          </div>
*/}
          <div className="form-group">
            Telefon Endkunde:
            <input className='form-control' name="telefon_lieferadresse" value={auftragRequest?.telefon_lieferadresse} onChange={handleChange} />
            {errors.telefon_lieferadresse && <p className="text-red-500">{errors.telefon_lieferadresse}</p>}
          </div>

          <div className="form-group">
            Mobil 1 Endkunde:
            <input className='form-control' name="mobil1_lieferadresse" value={auftragRequest?.mobil1_lieferadresse} onChange={handleChange} />
          </div>

          <div className="form-group">
            Mobil 2 Endkunde:
            <input className='form-control' name="mobil2_lieferadresse" value={auftragRequest?.mobil2_lieferadresse} onChange={handleChange} />
          </div>

          <div className="form-group">
            Email Endkunde:
            <input className='form-control' name="email" value={auftragRequest?.email_lieferadresse} onChange={handleChange} />
          </div>

          <div className="form-group">
            ggf Ansprechpartner:
            <input className='form-control' name="ansprechpartner" value={auftragRequest?.ansprechpartner} onChange={handleChange} />
          </div>

          <div className="form-group">
            Kontakt Ansprechpartner:
            <input className='form-control' name="kontakt_ansprechpartner" value={auftragRequest?.kontakt_ansprechpartner} onChange={handleChange} />
          </div>

          <div className="form-group">
            Besonderheiten:
            <textarea className='form-control' name="besonderheiten" rows={10} onChange={handleChangeTextarea} value={auftragRequest?.besonderheiten}></textarea>
          </div>

          <UploadContainer onFilesChange={handleFilesChange} />

          <p style={{ marginTop: "50px" }}></p>

          <div className="form-group">
            <input type="submit" className='btn btn-primary' value="Auftrag erteilen" onClick={speichern} />
          </div>

        </form>

      </div>

      <Footer />
    </div>
  );

}

